import Application from "../../Application";
import PublicationsReportPresenter, {
  IPublicationsReportPresenter
} from "../../presenter/report/PublicationsReportPresenter";
import { INotificationService } from "../../service/notification/NotificationService";
import { IReportService } from "../../service/report/ReportService";
import { TPublicationsReportApplicantPresentationModel } from "../../presenter/report/model/PublicationsReportApplicantPresentationModel";
import { IPublicationsReportRecord } from "../../model/report/PublicationsReportRecord";

export default class ShowPublicationsReportPageInteractor {
  private application: Application;
  private output?: IPublicationsReportPresenter;
  private reportService: IReportService;
  private notificationService: INotificationService;

  constructor(application, reportService, notificationService) {
    this.application = application;
    this.reportService = reportService;
    this.notificationService = notificationService;
  }

  async getPublicationsReportData() {
    try {
      const publicationsReportRecords =
        await this.reportService.getPublicationsReportData();
      return publicationsReportRecords;
    } catch (error) {
      this.notificationService.showError((error as any).message);
    }
  }

  execute() {
    this.output = PublicationsReportPresenter({
      application: this.application,
      initialState: {
        applicants: [] as TPublicationsReportApplicantPresentationModel[]
      }
    });

    this.getPublicationsReportData().then((data) => {
      this.output?.setApplicants(data || ([] as IPublicationsReportRecord[]));
    });
    return this.output;
  }
}
